import { Component } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';

interface PreguntaFrecuente {
  titulo: string;
  contenido: string;
  valor: number;
}

@Component({
  selector: 'allas-preguntas-frecuentes-afiliaciones',
  standalone: true,
  imports: [AccordionModule],
  template: `
    <section class="px-4 py-8">
      <!-- Titulo Beneficios del Programa -->
      <h2
        class="text-xl xl:text-4xl mb-2 xl:mb-6 mt-2 xl:mt-8 font-bold fs-condensed"
      >
        PREGUNTAS FRECUENTES
      </h2>

      <div>
        <p-accordion [value]="0" class="w-full">
          @for (pregunta of preguntas; track pregunta.valor) {
          <p-accordion-panel [value]="pregunta.valor">
            <p-accordion-header>
              <span
                class="text-sm xl:text-lg font-semibold fs-condensed text-gray-800"
              >
                {{ pregunta.titulo }}
              </span>
            </p-accordion-header>
            <p-accordion-content>
              <div>
                <p
                  class="m-0 text-xs xl:text-base"
                  [innerHTML]="pregunta.contenido"
                ></p>
              </div>
            </p-accordion-content>
          </p-accordion-panel>
          }
        </p-accordion>
      </div>
    </section>
  `,
})
export class PreguntasFrecuentesAfiliaciones {
  preguntas: PreguntaFrecuente[] = [
    {
      titulo: '¿Cómo me uno al programa Allas Repuestos Rewards?',
      contenido:
        'Puedes unirte en cualquiera de nuestras tiendas Allas Repuestos participantes o descargando la Aplicación desde tu celular en el App Store o Play Store.',
      valor: 0,
    },
    {
      titulo: '¿Cómo gano un crédito o punto?',
      contenido:
        'Ganas un punto cuando por cada Lempira de compra (antes de impuestos) en una compra calificada en tienda, en línea o con Recogida el Mismo Día en tienda. Solo necesitas tu codigo QR Recompensas Allas Repuestos, desde tu tarjeta digital en el ALLAS APP al comprar en tienda. Al comprar en Allas Repuestos.com o en la app, inicia sesión o ingresa tu ID de Recompensas al pagar. Para más detalle sobre créditos y compras calificadas, consulta los Términos y Condiciones completos.',
      valor: 1,
    },
    {
      titulo: 'Después de obtener X créditos, ¿cómo recibo mi Recompensa?',
      contenido:
        'La cantidad de créditos o puntos recompensa se reflejarán en tu cuenta de Recompensas Allas Repuestos (exclusivos Club) al momento de cancelar tu factura en caja, y será visible en tu App. En algunos casos puede tardar más. Si tienes dudas, escribenos al WhatsApp (504)2283-4540.',
      valor: 2,
    },
    {
      titulo: '¿Mis créditos o puntos Recompensas Allas Repuestos caducan?',
      contenido:
        'Las Recompensas de Allas Repuestos NO tienen fecha de caducidad. Para más detalle, consulta los Términos y Condiciones completos.',
      valor: 3,
    },
    {
      titulo:
        'Si olvido añadir mi ID de membresía en una transacción, ¿puedo aún ganar créditos y recompensas?',
      contenido: `1. Para poderle asignar puntos, créditos y/o Recompensas es necesario presentar el código QR de la Aplicación Allas Repuestos.
         
        <br/> <br/>2. o en su defecto hacer su compra en linea desde la aplicación y estar logueado con su cuenta de Recompensas Allas Repuestos (Exclusivos Club).
         
         <br/> <br/>También puedes escribenos al WhatsApp (504)2283-4540 para asistencia.`,
      valor: 4,
    },
  ];
}
